module.exports = __webpack_public_path__ + "img/toggle-moon.6f08f60d.svg";